module.exports = __webpack_public_path__ + "img/yes.c840e168.svg";